/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Payment_Link_Resend_FailedInputs */

const en_orders_payment_link_resend_failed = /** @type {(inputs: Orders_Payment_Link_Resend_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to resend payment link.`)
};

const es_orders_payment_link_resend_failed = /** @type {(inputs: Orders_Payment_Link_Resend_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo reenviar el link de pago.`)
};

/**
* | output |
* | --- |
* | "Failed to resend payment link." |
*
* @param {Orders_Payment_Link_Resend_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_payment_link_resend_failed = /** @type {((inputs?: Orders_Payment_Link_Resend_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Payment_Link_Resend_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_payment_link_resend_failed(inputs)
	return es_orders_payment_link_resend_failed(inputs)
});